import React, { createContext, ReactNode, useContext, useEffect, useState } from "react";
//import { useNavigate } from "react-router-dom";
import { postData } from "../services/ApiService";
import { Role } from "../utils/rolesUtil";
// Define types for User and Token
interface User {
    id: number
    name: string;
    phone: string;
    token: string;
    points: number;
    role: Role; // Add other user properties as needed
}

interface AuthContextType {
    user: User | null;
    login: (phone: string, password: string) => Promise<void>;
    logOut: () => void;
    isAuthenticated: boolean;
    role: Role;
}

// Create the context with a default value
const AuthContext = createContext<AuthContextType | undefined>(undefined);

// AuthProvider component with TypeScript types
interface AuthProviderProps {
    children: ReactNode;
}

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
    const [user, setUser] = useState<User | null>(null);

    useEffect(() => {
        // Check if the user is logged in by looking at localStorage
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
          setUser(JSON.parse(storedUser));
        }
      }, []);

    const isAuthenticated = user !== null;

    // loginAction: Handles user login
    const login = async (email: string, password: string) => {
        try {
            const res = await postData("/authenticate", {username: email , password})
            .catch((err: any) => {
                throw err;
            });
            if (res) {
                setUser(res); // Assume res is of type `User`
                localStorage.setItem("user", JSON.stringify(res)); // You can store the token if needed
                localStorage.setItem('token', res.token)
               // navigate("/tasks"); // Redirect to tasks page
                return;
            }
        } catch (err: any) {
            throw err;
        }
    };

    // logOut: Handles logging out the user
    const logOut = () => {
        setUser(null);
        localStorage.removeItem("user"); // Remove from localStorage if needed
        localStorage.removeItem("token");
    };

    const role = user?.role || Role.Customer; 

    return (
        <AuthContext.Provider value={{ user, login, logOut, isAuthenticated, role}}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;

// Custom hook to access AuthContext
export const useAuth = (): AuthContextType => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};

